import {RangeSelection} from 'lexical';

export const getSelectionPoints = (selection: RangeSelection) => {
    return [selection.anchor.offset, selection.focus.offset].sort((a, b) => a - b);
};
